// Phase 84.M.86 — Sticky top banner cảnh báo in-app browser. Hiện sau khi
// user dismiss modal, tới khi user bấm X (cùng session sẽ không hiện lại).
import { m as motion, AnimatePresence } from "framer-motion";
import { Warning, X, ArrowSquareOut } from "@phosphor-icons/react";
import { toast } from "sonner";
import { buildShareableUrl } from "../../lib/inAppBrowser";

export default function InAppBrowserBanner({ info, onClose }) {
  const appName = info?.app || "in-app browser";

  const handleCopy = async () => {
    const url = buildShareableUrl(typeof window !== "undefined" ? window.location.href : "");
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Đã sao chép đường dẫn", { description: "Dán vào Safari/Chrome." });
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        toast.success("Đã sao chép đường dẫn");
      } catch {
        toast.error("Không thể sao chép tự động. Hãy copy thanh địa chỉ.");
      }
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className="sticky top-0 z-[150] w-full bg-gradient-to-r from-[#FF8A00] to-[#FF9F1C] text-black shadow-[0_4px_18px_rgba(255,138,0,0.35)]"
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -40, opacity: 0 }}
        transition={{ duration: 0.25 }}
        data-testid="inapp-browser-banner"
      >
        <div className="max-w-5xl mx-auto px-3 py-1.5 flex items-center gap-2">
          <Warning size={16} weight="fill" className="text-black/85 shrink-0" />
          <div className="flex-1 min-w-0 text-[11.5px] font-bold leading-tight">
            Đang mở trong <span className="font-black">{appName}</span>. Để ổn
            định nhất hãy chuyển sang Safari/Chrome.
          </div>
          <button
            type="button"
            onClick={handleCopy}
            className="shrink-0 px-2.5 py-1 rounded-lg bg-black/15 hover:bg-black/25 text-[10.5px] font-black tracking-wider uppercase flex items-center gap-1 transition"
            data-testid="inapp-banner-copy"
          >
            <ArrowSquareOut size={11} weight="bold" />
            Copy link
          </button>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 w-6 h-6 rounded-full bg-black/10 hover:bg-black/25 flex items-center justify-center transition"
            aria-label="Đóng cảnh báo"
            data-testid="inapp-banner-close"
          >
            <X size={11} weight="bold" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
